export default __webpack_public_path__ + "static/media/alert-icon.6fb125a9.svg";